const TOKEN_KEY = "aeos_access_token";
const REFRESH_KEY = "aeos_refresh_token";

export function getAccessToken(): string | null {
  return localStorage.getItem(TOKEN_KEY);
}

export function setTokens(access: string, refresh: string): void {
  localStorage.setItem(TOKEN_KEY, access);
  localStorage.setItem(REFRESH_KEY, refresh);
}

export function clearTokens(): void {
  localStorage.removeItem(TOKEN_KEY);
  localStorage.removeItem(REFRESH_KEY);
}

export function getRefreshToken(): string | null {
  return localStorage.getItem(REFRESH_KEY);
}

export function isAuthenticated(): boolean {
  const token = getAccessToken();
  if (!token) return false;
  try {
    const parts = token.split(".");
    if (parts.length !== 3) return false;
    const payload = JSON.parse(atob(parts[1]!)) as { exp?: number };
    const exp = payload.exp;
    return typeof exp === "number" && exp * 1000 > Date.now();
  } catch {
    return false;
  }
}

/**
 * Return the authenticated user's subject claim from the stored JWT.
 * Falls back to "unknown" if the token is absent or malformed.
 */
export function getCurrentUserId(): string {
  const token = getAccessToken();
  if (!token) return "unknown";
  try {
    const parts = token.split(".");
    if (parts.length !== 3) return "unknown";
    const payload = JSON.parse(atob(parts[1]!)) as { sub?: string };
    return payload.sub ?? "unknown";
  } catch {
    return "unknown";
  }
}

/**
 * Return the institution_id claim from the stored JWT.
 * This is the logical institution identifier (e.g. "I-003") used as
 * lender_id on cases and for data-isolation filtering on GET /api/cases.
 * Falls back to null if the token is absent, malformed, or the user
 * has no institution affiliation.
 */
export function getCurrentInstitutionId(): string | null {
  const token = getAccessToken();
  if (!token) return null;
  try {
    const parts = token.split(".");
    if (parts.length !== 3) return null;
    const payload = JSON.parse(atob(parts[1]!)) as { institution_id?: string };
    return payload.institution_id ?? null;
  } catch {
    return null;
  }
}
